import React from 'react';
import DatePicker from './DatePicker';
import {Grid, Typography} from '@material-ui/core';
import {getLabels} from '../constants/labels';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    group: {
        padding: '0px 0px 10px 0px'
    },
    fromLabel: {
        marginTop: 7,
        marginRight: 20,
        fontSize: 14
    },
    enToLabel:{
        marginTop: 7,
        marginRight: 39,
        fontSize: 14
    },
    esToLabel:{
        marginTop: 7,
        marginRight: 24,
        fontSize: 14
    },
    total:{
        marginBottom:'15px'
    }
}));

export default function DateFilter({minDate, maxDate, handleChange, language = 'en'}) {
    const classes = useStyles();
    const labels = getLabels(language);
    return (
        <Grid container className={classes.total} alignItems='center'>
            <Grid item
                container
                xs={12}
                direction="row"
                alignItems="center"
                justifyContent='center'
                className={classes.group}
            >
                <Typography className={classes.fromLabel}>
                    <b>{labels.dateFrom}:</b>
                </Typography>
                <DatePicker id='fromDate'
                            value={minDate}
                            handleChange={handleChange}
                            maxDate={maxDate || undefined}
                />
            </Grid>
            <Grid item
                container
                xs={12}
                direction="row"
                alignItems="center"
                justifyContent='center'
                className={classes.group}>
                <Typography className={language==='en'? classes.enToLabel : classes.esToLabel}>
                    <b>{labels.dateTo}:</b>
                </Typography>
                <DatePicker id='toDate'
                            value={maxDate}
                            handleChange={handleChange}
                            minDate={minDate || undefined}
                />
            </Grid>
        </Grid>
    );
}
